export const NewLoanTypes = {
    PTS_LEASING: "ПТС Лизинг",
    HOLD_LT: "Стоянка (ЗБ)",
    NOT_SURE: "Не определился"
};

export const LoanTypes = {
    PTS: "ПТС ДКП",
    PTS_P2P: "ПТС Ф-Ф",
    PTS_LEASING: "ПТС Лизинг",
    HOLD: "Стоянка",
    HOLD_LT: "Стоянка (ЗБ)",
    NOT_SURE: "Не определился"
};

export const LoanStatuses = {
    DRAFT: "Черновик",
    SECURITY_CHECK: "Отправлено в СБ",
    APPROVED: "Одобрено",
    ACTIVE: "Займ выдан",
    TRADE: "В продаже",
    CLOSED: "Займ закрыт",
    DENIED: "Отказано"
};

export const Office = {
    NEWCHERKASSKY: "НОВОЧЕРКАССКИЙ ПР., Д. 1",
    MOSCOW: "МОСКОВСКОЕ Ш. 13А"
};

export const Source = {
    INCOMING: "Входящий звонок",
    OUTGOING: "Исходящий звонок",
    SITE: "Сайт",
    VISIT: "Визит",
    BROKER: "Брокер",
    REPEAT: "Повторное обращение"
};

export const Permissions = {
    clients: "Раздел Заявки",
    "client-comment-delete": "Удаление комментариев",
    client: "Управление Заявкой / Договором",
    contracts: "Раздел Договоры",
    "contract-manager": "Функционал Менеджмента",
    "contract-security": "Функционал Службы Безопасности",
    "contracts-read-owner": "Поиск Договоров других менеджеров",
    "contracts-read-newcherkassky": "Поиск Договоров от офиса НВЧ",
    "contracts-read-moscow": "Поиск Договоров от офиса МСК",
    "contracts-search-rough": "Нестрогий поиск по Договорам",
    "contracts-extra": "Дополнительная информация к Договорам",
    dashboard: "Раздел Управление",
    bookkeeping: "Раздел Бухгалтерия",
    "users-edit": "Редактирование Пользователей",
    "forms-full-access": "Дополнительные поля в формах"
};

export const DenialReasons = {
    managerReasons: {
        conviction: "Судимость",
        debts: "Долги ФССП",
        negativeHistory: "Негативный отчет НБКИ",
        activeLoan: "Запрет ГИБДД / Активный залог",
        missedPTS: "Отсутствует ПТС",
        garbage: "Неликвидный ТС"
    },
    clientReasons: {
        necessity: "Отсутствует надобность",
        conditions: "Не устроили условия",
        silence: "Не отвечает на звонки"
    }
};

export const Transaction = {
    OperationSides: {
        DEBIT: "Дебет",
        CREDIT: "Кредит"
    },
    OperationSources: {
        User: "Сотрудник",
        Contract: "Договор",
        Credit: "Кредит"
    },
    OperationProlongationAliases: {
        PTS: "CONTRACT_PROLONGATION_PTS",
        PTS_P2P: "CONTRACT_PROLONGATION_PTS_P2P",
        PTS_LEASING: "CONTRACT_PROLONGATION_PTS_LEASING",
        HOLD: "CONTRACT_PROLONGATION_HOLD",
        HOLD_LT: "CONTRACT_PROLONGATION_HOLD_LT",
        CREDIT: "CREDIT_PROLONGATION_CREDIT",
        INNER: "CREDIT_PROLONGATION_INNER",
        EXTERNAL: "CREDIT_PROLONGATION_EXTERNAL"
    },
    OperationRepayAliases: {
        CREDIT: "CREDIT_REPAY_CREDIT",
        INNER: "CREDIT_REPAY_INNER",
        EXTERNAL: "CREDIT_REPAY_EXTERNAL"
    },
    OperationSignAliases: {
        PTS: "CONTRACT_SIGN_PTS",
        PTS_P2P: "CONTRACT_SIGN_PTS_P2P",
        PTS_LEASING: "CONTRACT_SIGN_PTS_LEASING",
        HOLD: "CONTRACT_SIGN_HOLD",
        HOLD_LT: "CONTRACT_SIGN_HOLD_LT",
        EXTERNAL: "CREDIT_SIGN_EXTERNAL",
        INNER: "CREDIT_SIGN_INNER"
    },
    OperationAttractAliases: {
        CREDIT: "CREDIT_ATTRACT_CREDIT",
        EXTERNAL: "CREDIT_ATTRACT_EXTERNAL",
        INNER: "CREDIT_ATTRACT_INNER"
    },
    OperationCloseAliases: {
        PTS: "CONTRACT_CLOSE_PTS",
        PTS_P2P: "CONTRACT_CLOSE_PTS_P2P",
        PTS_LEASING: "CONTRACT_CLOSE_PTS_LEASING",
        HOLD: "CONTRACT_CLOSE_HOLD",
        HOLD_LT: "CONTRACT_CLOSE_HOLD_LT",
        INNER: "CREDIT_CLOSE_INNER",
        EXTERNAL: "CREDIT_CLOSE_EXTERNAL"
    },
    OperationRefundAliases: {
        CREDIT: "CREDIT_REFUND_CREDIT",
        INNER: "CREDIT_REFUND_INNER",
        EXTERNAL: "CREDIT_REFUND_EXTERNAL"
    },
    Departments: {
        NEWCHERKASSKY: "НВЧ",
        MOSCOW: "МСК",
        ADMINISTRATION: "Управление"
    },
    Companies: {
        AUTOFINANCE: `ЗАО «АвтоФинанс»`,
        PAWNSHOP: `ООО «ЛОМБАРД "АВТОМОБИЛЬНОСТЬ"»`,
        LEASING: `ООО «ЛИЗИНГОВАЯ КОМПАНИЯ "АВТОМОБИЛЬНОСТЬ"»`
    },
    CounterpartyTypes: {
        NATURAL_PERSON: "Физическое лицо",
        JURIDICAL_PERSON: "Юридические лицо",
        SP: "ИП",
        EMPLOYEE: "Сотрудник",
        CLIENT: "Клиент"
    }
};

export const Credit = {
    Types: {
        CREDIT: "Кредит",
        EXTERNAL: "Внешний займ",
        INNER: "Внутренний займ"
    },
    Sides: {
        DEBIT: "Привлечение",
        CREDIT: "Выдача"
    },
    Statuses: {
        ACTIVE: "Активный",
        CLOSED: "Закрыт"
    }
};

export const smsTemplates = {
    natural_person: `В продолжении нашего разговора, отправляю Вам электронную почту. info@zalog.am
Для получения предварительного одобрения по сумме Вам необходимо отправить след.документы:
1. Скан ПТС с 2-х сторон.
2. Свидетельство ТС.
3. Паспорт владельца.
Мы являемся офиц.дилером Hyundai, Isuzu, Foton.
С информацией о нашей компании ГК АВТОМОБИЛЬНОСТЬ, вы можете ознакомиться на сайте www.commercial.am
Ждём Вас в наших офисах с 10:00-19:00, в выходные с 10:00-19:00
Московское шоссе,13А
Новочеркасский пр.1
Тел: 458-35-35`,
    juridical_person: `В продолжении нашего разговора, отправляю Вам электронную почту. info@zalog.am
Для получения предварительного одобрения по сумме Вам необходимо отправить след.документы:
1. Скан ПТС с 2-х сторон.
2. Свидетельство ТС.
3. Уставные документы юр.лица (Приказ о назначении руководителя, Свидетельство ИНН, Свидетельство ОГРН, паспорт руководителя)
4. Несколько фото а/м.
Мы являемся офиц.дилером Hyundai, Isuzu, Foton. С информацией о нашей компании ГК АВТОМОБИЛЬНОСТЬ, вы можете ознакомиться на сайте www.commercial.am
Ждём Вас в наших офисах с 10:00-19:00, в выходные с 10:00-19:00
Московское шоссе,13А
Новочеркасский пр.1
Тел: 458-35-35`,
    requisites:
        "Сбер: 5336690071015699 Анастасия Юрьевна, без назначения платежа."
};

export const Activities = [
    "Автосалон б/у",
    "Автосалон дилер",
    "Страховой брокер",
    "Кредитный брокер",
    "СТО",
    "Магазин автозапчастей",
    "Другое"
];

export const DADATA_TOKEN = "d1eb73a80efc7afd745c318e28b68d722471d573";

export const Dates = {
    _30Days: 2592000000, // 30*24*60*60*1000
    _31Days: 2678400000, // 31*24*60*60*1000
    _5Days: 432000000, // 5*24*60*60*1000
    _1Day: 86400000 // 24*60*60*1000
};

export const Masks = {
    phone: [
        "+",
        "7",
        " ",
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/
    ], // "+7 (999) 999-99-99"
    passport: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/], // "4019 987451"
    date: [/[0-3]/, /\d/, ".", /[0-1]/, /\d/, ".", /[1-2]/, /\d/, /\d/, /\d/], // "01.02.1998"
    year: [/[1-2]/, /\d/, /\d/, /\d/], // "1998"
    passportSerie: [/\d/, /\d/, /\d/, /\d/], // "4018"
    passportNumber: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/], // "409827"
    inn: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/], // "9999999999"
    kpp: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/], // "999999999"
    ogrn: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ], // "9999999999999",
    account: [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/
    ], // "9999999999999",
    vin: [
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./,
        /./
    ], // "*".repeat(17)
    registrationNumber: [
        /[a-zA-Zа-яА-Я]/,
        /\d/,
        /\d/,
        /\d/,
        /[a-zA-Zа-яА-Я]/,
        /[a-zA-Zа-яА-Я]/,
        /\d/,
        /\d/,
        /\d/
    ], // "x999xx999"
    ptsSerie: [/\d/, /\d/, /./, /./], // "99**"
    ptsNumber: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/], // "999999",
    stsSerie: [/./, /./, /./, /./], //"****",
    stsNumber: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/], // "999999"
    code: [/\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/], // "999-999",
    keyNumber: [/[1-9]/], // "9"
    vat: [/[1-9]/, /[1-9]/]
};



// WEBPACK FOOTER //
// ./src/constants/enums.js